import(/* webpackMode: "eager", webpackExports: ["ReadingProgress"] */ "/tmp/8de9b0a15bd30af/components/blog/ReadingProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8de9b0a15bd30af/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents"] */ "/tmp/8de9b0a15bd30af/components/blog/TableOfContents.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/components/blog/PrevNextNav.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/node_modules/next/dist/client/link.js");
